/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type IntervalDefinitionFreqTypeEnum = "Daily" | "Monthly" | "Weekly" | "Yearly" | "%future added value";
export type OnboardingOrgInviteEventQueryVariables = {
    orgRelayId: string;
    week: unknown;
};
export type OnboardingOrgInviteEventQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly calculateSmartHoldsErrorable?: ({
            readonly __typename: "SmartHoldCalculationResult";
            readonly events: ReadonlyArray<{
                readonly title: string | null;
                readonly attendeePeople: {
                    readonly __typename: "PersonList";
                    readonly list: ReadonlyArray<{
                        readonly id: string;
                        readonly isUser: boolean;
                        readonly isYou: boolean;
                        readonly primaryEmail: string;
                        readonly profile: {
                            readonly givenName: string | null;
                        } | null;
                    }>;
                } | {
                    /*This will never be '%other', but we need some
                    value in case none of the concrete values match.*/
                    readonly __typename: "%other";
                };
                readonly recurrenceRules: {
                    readonly interval: {
                        readonly interval: number;
                        readonly freqType: IntervalDefinitionFreqTypeEnum;
                    } | null;
                } | null;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
    } | null;
};
export type OnboardingOrgInviteEventQuery = {
    readonly response: OnboardingOrgInviteEventQueryResponse;
    readonly variables: OnboardingOrgInviteEventQueryVariables;
};



/*
query OnboardingOrgInviteEventQuery(
  $orgRelayId: ID!
  $week: LocalWeek!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      id
      calculateSmartHoldsErrorable(week: $week) {
        __typename
        ... on SmartHoldCalculationResult {
          events {
            title
            attendeePeople {
              __typename
              ... on PersonList {
                list {
                  id
                  isUser
                  isYou
                  primaryEmail
                  profile {
                    givenName
                  }
                }
              }
            }
            recurrenceRules {
              interval {
                interval
                freqType
              }
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "week"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "week",
                        "variableName": "week"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "calculateSmartHoldsErrorable",
                "plural": false,
                "selections": [
                    (v3 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "events",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "attendeePeople",
                                        "plural": false,
                                        "selections": [
                                            (v3 /*: any*/),
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Person",
                                                        "kind": "LinkedField",
                                                        "name": "list",
                                                        "plural": true,
                                                        "selections": [
                                                            (v2 /*: any*/),
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "isUser",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "isYou",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "primaryEmail",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "UserProfile",
                                                                "kind": "LinkedField",
                                                                "name": "profile",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "givenName",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "type": "PersonList",
                                                "abstractKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RecurrenceRules",
                                        "kind": "LinkedField",
                                        "name": "recurrenceRules",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "IntervalDefinition",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "interval",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "freqType",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SmartHoldCalculationResult",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingOrgInviteEventQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "OnboardingOrgInviteEventQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v2 /*: any*/),
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "4a70cc45e64d6b22dff85776166c1cc4",
            "id": null,
            "metadata": {},
            "name": "OnboardingOrgInviteEventQuery",
            "operationKind": "query",
            "text": "query OnboardingOrgInviteEventQuery(\n  $orgRelayId: ID!\n  $week: LocalWeek!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      id\n      calculateSmartHoldsErrorable(week: $week) {\n        __typename\n        ... on SmartHoldCalculationResult {\n          events {\n            title\n            attendeePeople {\n              __typename\n              ... on PersonList {\n                list {\n                  id\n                  isUser\n                  isYou\n                  primaryEmail\n                  profile {\n                    givenName\n                  }\n                }\n              }\n            }\n            recurrenceRules {\n              interval {\n                interval\n                freqType\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '42295e6c7704a4cabb75f3667d5a9845';
export default node;
